module.exports = __webpack_public_path__ + "img/6双人标准套房.4c507ae.jpg";